module.exports = __webpack_public_path__ + "static/img/BA.ebc1bb9f.png";